import { QueueMusic } from "@mui/icons-material"
import { IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { isShowingQueueDisplayer } from "../../reducers/randomMode";
import { setShowingQueueDisplayer } from "../../actions/randomModeActions";
import { anyDisablingProcess } from "../../reducers/disablingProcesses";
import { useCallback } from "react";

const RandomQueueToggle = ({size}) => {
    const showingQueueDisplayer = useSelector(isShowingQueueDisplayer);
    const disabled = useSelector(anyDisablingProcess);
    const dispatch = useDispatch();

    const onClick = useCallback(() => { 
        dispatch(setShowingQueueDisplayer(!showingQueueDisplayer)) 
    }, [showingQueueDisplayer, dispatch]);

    return (
        <IconButton onClick={onClick} disabled={disabled} size={size}>
            <QueueMusic htmlColor={showingQueueDisplayer ? "white" : undefined} fontSize={size} />
        </IconButton>
    )
}

export default RandomQueueToggle;